/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ stopped: NonNullable<unknown>, offline: NonNullable<unknown> }} Station_Fleet_Stopped_CountInputs */

const vi_station_fleet_stopped_count = /** @type {(inputs: Station_Fleet_Stopped_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.stopped} dừng · ${i?.offline} mất tín hiệu`)
};

/**

* @param {Station_Fleet_Stopped_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_fleet_stopped_count = /** @type {((inputs: Station_Fleet_Stopped_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Fleet_Stopped_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_fleet_stopped_count(inputs)
});